import React, { useState } from "react";

import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import swal from "sweetalert";

import CustomGreenButton from "./custom-green-button";
import { GENERAL_URL_API } from "../../shared/urls";
import { fetchSuperInstitutos } from "../../shared/fetchers/classics/institutos/verSuperInstitutos";
import { fetchInstitutos } from "../../shared/fetchers/classics/institutos/verInstitutos";

const ClienteFiltro = ({ onSubmit, submitting = false, tipos = [
  { tipo: "Individual" },
  { tipo: "Instituto" },
  { tipo: "Personal" },
] }) => {
  const [tipoValue, setTipoValue] = useState(null);
  const [error, setError] = useState(false);
  const [check, setCheck] = useState(false);

  const [clientes, setClientes] = useState([]);

  // Estados para Instituto -> Super, Institutos, Usuarios
  const [superInstitutos, setSuperInstitutos] = useState([]);
  const [selectedSuperInstituto, setSelectedSuperInstituto] = useState(null);
  const [institutos, setInstitutos] = useState([]);
  const [selectedInstitutos, setSelectedInstitutos] = useState([]);
  const [clientesInstituto, setClientesInstituto] = useState([]);
  const [selectedUsuarios, setSelectedUsuarios] = useState([]);

  const [formData, setFormData] = useState({
    fechaIni: { value: "", error: false },
    fechaFin: { value: "", error: false },
  });

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const updateForm = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: { value: value, error: false } });
  };

  const usuariosUpdate = (e, newValue) => {
    setSelectedUsuarios(newValue ?? []);
  };

  const institutosSelectedUpdate = async (e, newValue) => {
    setSelectedInstitutos(newValue ?? []);
    setSelectedUsuarios([]);

    if (newValue && newValue.length > 0) {
      try {
        const fd = new FormData();
        fd.append("show", "all");
        fd.append("tipoUsuario", "Instituto");
        const res = await fetch(`${GENERAL_URL_API}/verDatos/verClientes.php`, {
          method: "POST", credentials: 'include',
          body: fd,
        });
        const resJSON = await res.json();
        if (resJSON.status === 0) {
          setClientesInstituto([]);
        } else {
          const nombresSeleccionados = new Set((newValue ?? []).map((i) => i?.nombre ?? i));
          const filtrados = (resJSON.data ?? []).filter((c) => nombresSeleccionados.has(c.institute));
          setClientesInstituto(filtrados);
        }
      } catch (e) {
        setClientesInstituto([]);
      }
    } else {
      setClientesInstituto([]);
    }
  };

  const onSuperInstitutoChange = async (_, value) => {
    setSelectedSuperInstituto(value);
    setSelectedInstitutos([]);
    setClientesInstituto([]);
    setSelectedUsuarios([]);

    try {
      const lista = await fetchInstitutos();
      const filtrados = value
        ? lista.filter((inst) => (inst.superInstituto ?? inst.superinstituto ?? "") === (value.nombre ?? value))
        : lista;
      setInstitutos(filtrados);
    } catch (e) {
      setInstitutos([]);
    }
  };

  const onTipoChange = async (e, newValue) => {
    if (newValue) {
      setError(false);
      setTipoValue(newValue);
    }

    setSelectedSuperInstituto(null);
    setInstitutos([]);
    setSelectedInstitutos([]);
    setClientesInstituto([]);
    setSelectedUsuarios([]);

    const fd = new FormData();
    fd.append("show", "all");
    fd.append("tipoUsuario", newValue.tipo);
    const res = await fetch(`${GENERAL_URL_API}/verDatos/verClientes.php`, {
      method: "POST", credentials: 'include',
      body: fd,
    });
    const resJSON = await res.json();
    if (resJSON.status === 0) {
      setCheck(false);
      await swal({ title: "Error", text: resJSON.info, icon: "error" });
    } else {
      setCheck(true);
      setClientes(resJSON.data);
      setClientesInstituto(resJSON.data);
    }

    if (newValue?.tipo === "Instituto") {
      try {
        const data = await fetchSuperInstitutos();
        setSuperInstitutos(data ?? []);
      } catch (e) {
        setSuperInstitutos([]);
      }
      return;
    }
  };

  const buildUsuariosCsv = () => {
    return (selectedUsuarios ?? []).length > 0
      ? selectedUsuarios.map((u) => u.username).join(",")
      : "";
  };

  const handleSubmit = async () => {
    if (!tipoValue) {
      setError(true);
      await swal({ title: "Error", text: "Seleccione un tipo de cliente", icon: "error" });
      return;
    }

    const filtros = {
      tipoUsuario: tipoValue?.tipo || "",
      usuarios: (selectedUsuarios || []).map((u) => u.username),
      usuariosCsv: buildUsuariosCsv(),
      fechaInicio: formData.fechaIni.value || "",
      fechaFin: formData.fechaFin.value || "",
      superInstituto: selectedSuperInstituto?.nombre || "",
      institutos: (selectedInstitutos || []).map((i) => i?.nombre),
    };

    onSubmit && onSubmit(filtros);
  };

  return (
    <div>
      <div className="d-flex align-items-center">
        <AccountBalanceIcon style={{ fontSize: "17px" }} />
        <div className="admin-main-title-dark-gray ml-2 mt-1">
          Selecciona un cliente (Dejar vacio para ver el reporte general)
        </div>
      </div>
      <form>
        <label className="admin-label-text mt-3 d-block">Tipo usuario:</label>
        <Autocomplete
          options={tipos}
          disableClearable
          getOptionLabel={(option) => option.tipo}
          value={tipoValue}
          onChange={onTipoChange}
          noOptionsText="Sin resultados"
          renderInput={(params) => (
            <TextField
              {...params}
              error={error}
              helperText={error ? "Seleccione un tipo de cliente" : null}
              variant="outlined"
              size="small"
              style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
            />
          )}
        />
        {check && (
          <div>
            {tipoValue?.tipo === "Instituto" ? (
              <>
                <label className="admin-label-text mt-3 d-block">Super Instituto (Dejar vacío para reporte general):</label>
                <Autocomplete
                  options={superInstitutos}
                  getOptionLabel={(option) => option?.nombre ?? ""}
                  value={selectedSuperInstituto}
                  onChange={onSuperInstitutoChange}
                  noOptionsText="Sin resultados"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder="Selecciona un super instituto (opcional)"
                      style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
                    />
                  )}
                />

                <label className="admin-label-text mt-3 d-block">Institutos (Dejar vacío para reporte general):</label>
                <Autocomplete
                  multiple
                  options={institutos}
                  getOptionLabel={(option) => option?.nombre ?? ""}
                  value={selectedInstitutos}
                  disableCloseOnSelect
                  noOptionsText="Sin resultados"
                  onChange={institutosSelectedUpdate}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} color="primary" />
                      {option?.nombre}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
                    />
                  )}
                />

                <label className="admin-label-text mt-3 d-block">Usuarios (Dejar vacío para reporte general por institutos seleccionados):</label>
                <Autocomplete
                  multiple
                  options={clientesInstituto}
                  getOptionLabel={(option) => option.username}
                  value={selectedUsuarios}
                  disableCloseOnSelect
                  noOptionsText="Sin resultados"
                  onChange={usuariosUpdate}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} color="primary" />
                      {option.username}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
                    />
                  )}
                />

                <label className="admin-label-text mt-3 d-block">Entre las fechas (Si no selecciona ninguna se mostraran los ultimos 5000 registros):</label>
              </>
            ) : (
              <>
                <label className="admin-label-text mt-3 d-block">Buscar (Si no selecciona ninguno se mostrara el reporte general):</label>
                <Autocomplete
                  multiple
                  options={clientes}
                  getOptionLabel={(option) => option.username}
                  value={selectedUsuarios}
                  disableCloseOnSelect
                  noOptionsText="Sin resultados"
                  onChange={usuariosUpdate}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} color="primary" />
                      {option.username}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
                    />
                  )}
                />
                <label className="admin-label-text mt-3 d-block">Entre las fechas (Si no selecciona ninguna se mostraran los ultimos 5000 registros):</label>
              </>
            )}
            <div className="d-flex">
              <TextField
                name="fechaIni"
                value={formData.fechaIni.value}
                onChange={updateForm}
                variant="outlined"
                size="small"
                type="date"
                style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
              />
              <CustomGreenButton
                variant="contained"
                style={{ height: "40px", pointerEvents: "none" }}
                className="d-block d-md-inline"
                disableTouchRipple
                disableRipple
                disableElevation
                disableFocusRipple
              >
                Hasta
              </CustomGreenButton>
              <TextField
                name="fechaFin"
                value={formData.fechaFin.value}
                onChange={updateForm}
                variant="outlined"
                size="small"
                type="date"
                style={{ width: "180px", fontFamily: "'Noto Sans JP', sans-serif" }}
              />
            </div>
            <br />
            <CustomGreenButton
              variant="contained"
              className="mt-4"
              onClick={handleSubmit}
              disabled={submitting}
            >
              Consultar
            </CustomGreenButton>
          </div>
        )}
      </form>
    </div>
  );
};

export default ClienteFiltro;


